import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardService } from './dashboard.service';

// import EXAMPLE_WF_CONF from '../../../../modules/example/workflows/workflow-config';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkflowStateManager } from '../../../../workflow/workflow-state-manager';
import { Workflow, Task, Transition } from '../../../../workflow/types';
import { McbGridColumnType } from '../../../../../infra/components/grid/type/enum/mcb-grid-column-type';
import { McbGridColumn } from '../../../../../infra/components/grid/type/mcb-grid-column-dto';
import { McbGridAction } from '../../../../../infra/components/grid/type/mcb-grid-action-dto';
import { McbGrid } from '../../../../../infra/components/grid/type/mcb-grid-dto';
const EXAMPLE_WF_CONF = {workflows: []};

@Component({
    selector: 'mcb-dashboard', templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnDestroy {
    private workflows: Workflow[] = [];
    tasks: Task[] = [];
    gridColumns: McbGridColumn[] = [
        { title: 'گردش کار', field: 'workflowTitle' },
        { title: 'شناسه', field: 'workflowInstanceId' },
        { title: 'گام', field: 'stateTitle' },
        { title: 'وضعیت', field: 'stateTitle' },
        { title: 'تاریخ ایجاد', field: 'createDate', type: McbGridColumnType.JALALIDATE },
        { title: 'ارجاع دهنده', field: 'referrerTitle' }
    ];

    gridActions: McbGridAction[] = [
        // { type: McbGridActionType.BUTTON, actionClick: x => this.onViewTaskClick(x), text: 'اقدام' }
    ];

    constructor(
        private service: DashboardService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public stateManager: WorkflowStateManager) {

        stateManager.done.subscribe(x => this.handleTaskDoneRequest());
        stateManager.enableTransition.subscribe(x => this.handleEnableTransitionRequest(x));
        this.workflows = [].concat(EXAMPLE_WF_CONF.workflows);

        // If a 'state processor' is alredy loaded, return to dashboard root
        if (activatedRoute.children.some(ch => ch.outlet === 'processor')) {
            this.redirectToDashboardRoot();
        }

        this.handleBrowserNavigations();
    }

    private handleBrowserNavigations() {
        // this.router.events
        //     .filter(event => event instanceof NavigationStart)
        //     .subscribe((event: NavigationStart) => {

        //     });
    }

    onViewTaskClick(task: Task) {
        const state = this.findWorkflowState(task);
        if (state) {
            this.stateManager.task = task;
            const route = [{ outlets: { processor: [`w${task.workflowId}-s${task.stateId}`] } }];
            this.router.navigate(route, { relativeTo: this.activatedRoute });
        } else {
            console.log('workflow state processor not found!');
        }
    }

    private findWorkflowState(task: Task) {
        const wf = this.workflows.find(w => w.id === task.workflowId);
        if (wf) {
            const state = wf.states.find(s => s.id === task.stateId);
            if (state) {
                return state;
            }
        }
        return null;
    }

    onGridChagne(e: McbGrid) {
        this.service.getTasks().subscribe(t => this.tasks = t);
    }

    onReturnClick() {
        this.stateManager.reset();
        this.redirectToDashboardRoot();
        this.stateManager.returnClick.next();
    }

    onTransitionButtonClick(t: Transition) {
        this.stateManager.transitionClick.next(t);
    }

    private handleEnableTransitionRequest(req: { transitionId: number; enabled: boolean; }): void {
        const transition = this.stateManager.task.transitions.find(t => t.id === req.transitionId);
        transition.enabled = req.enabled;
    }

    private handleTaskDoneRequest() {
        this.stateManager.reset();
        this.redirectToDashboardRoot();
    }

    private redirectToDashboardRoot() {
        const route = [{ outlets: { processor: null } }];
        this.router.navigate(route, { relativeTo: this.activatedRoute });
    }

    ngOnDestroy() {
        this.stateManager.reset();
    }
}
